import { render } from "./ApproveRequest.vue?vue&type=template&id=2c6e8ef5"
import script from "./ApproveRequest.vue?vue&type=script&lang=js"
export * from "./ApproveRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__